import userService from "../../../services/user.service";

async function getTaskTypes({ pageNumber, pageSize, searchQuery }) {
  try {
    const response = await userService.getTaskTypes(pageNumber, pageSize, searchQuery);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch task types."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching task types:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addTaskTypeToDatabase({ taskTypeName, taskTypeDescription, isActive }) {
  try {
    const payload = {
      name: taskTypeName,
      description: taskTypeDescription,
      active: isActive,
    };
    const response = await userService.addTaskType(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to add task type."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding task type:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateTaskTypeInDatabase({ taskTypeId, taskTypeName, taskTypeDescription, isActive }) {
  try {
    const payload = {
      id: taskTypeId,
      name: taskTypeName,
      description: taskTypeDescription,
      active: isActive,
    };
    const response = await userService.updateTaskType(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update task type."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating task type:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addTaskTypeToDatabase,
  getTaskTypes,
  updateTaskTypeInDatabase,
  taskTypeTools: [
    {
      type: "function",
      function: {
        name: "getTaskTypes",
        description: "Fetch all task types from the database with pagination and search query.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
              type: "number",
              description: "The page number for paginated results. by default it is -1 for fetching all tasks types",
            },
            pageSize: {
              type: "number",
              description: "The number of items per page. by default it is 0 for fetching all task types",
            },
            searchQuery: {
              type: "string",
              description: "Search query to filter task types. by default it is empty string for fetching all task types",
            },
          },
          required: ["pageNumber", "pageSize", "searchQuery"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateTaskTypeInDatabase",
        description: "Update an existing task type in the database.",
        parameters: {
          type: "object",
          properties: {
            taskTypeId: {
              type: "string",
              description: "The unique ID of the task type to be updated.",
            },
            taskTypeName: {
              type: "string",
              description: "Name of the task type.",
            },
            taskTypeDescription: {
              type: "string",
              description: "Description of the task type.",
            },
            isActive: {
              type: "boolean",
              description: "Whether the task type is active or not.",
            },
          },
          required: ["taskTypeId", "taskTypeName", "taskTypeDescription"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addTaskTypeToDatabase",
        description: "Add a new task type to the database.",
        parameters: {
          type: "object",
          properties: {
            taskTypeName: {
              type: "string",
              description: "Name of the task type.",
            },
            taskTypeDescription: {
              type: "string",
              description: "Description of the task type.",
            },
            isActive: {
              type: "boolean",
              description: "Whether the task type is active or not.",
            },
          },
          required: ["taskTypeName", "taskTypeDescription"],
        },
      },
    },
  ],
};
